import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-job-configuration',
    templateUrl: './his-job-configuration.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisJobConfigurationComponent {

    @Output() startJobClicked = new EventEmitter();

    @Input() settings: any[];

    jobConfigurationVisible = false;

    showJobConfiguration() {
        this.jobConfigurationVisible = true;
    }

    hideJobConfiguration() {
        this.jobConfigurationVisible = false;
    }


    areSettingsValid( settings: any[]): boolean {
        let result = true;

        for ( const setting of settings ) {
            if ( setting.active === false ) {
                continue;
            }
            if ( setting.settings ) {
            	result = result && this.areSettingsValid( setting.settings );
            } else if ( setting.childSettings ) {
                result = result && this.areSettingsValid( setting.childSettings );
            } else {
                if (setting.required) {
                    if (!setting.selectedValue && !setting.value) {
                        result = false;
                    }
                }
            }
        }

        return result;
    }
}
